/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Discover_HeadingInputs */

const th_discover_heading = /** @type {(inputs: Discover_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ค้นหาการแข่งขัน`)
};

const en_discover_heading = /** @type {(inputs: Discover_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What's on the court`)
};

const ja_discover_heading = /** @type {(inputs: Discover_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コート最新情報`)
};

const zh_discover_heading = /** @type {(inputs: Discover_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在发生的事`)
};

const es_discover_heading = /** @type {(inputs: Discover_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qué hay en la pista`)
};

const pt_discover_heading = /** @type {(inputs: Discover_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que está rolando na quadra`)
};

const id_discover_heading = /** @type {(inputs: Discover_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yang sedang berlangsung`)
};

const fr_discover_heading = /** @type {(inputs: Discover_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce qui se joue`)
};

const tl_discover_heading = /** @type {(inputs: Discover_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ang nangyayari`)
};

const vi_discover_heading = /** @type {(inputs: Discover_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chuyện đang diễn ra`)
};

const ko_discover_heading = /** @type {(inputs: Discover_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`지금 벌어지는 일`)
};

const de_discover_heading = /** @type {(inputs: Discover_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was auf dem Feld los ist`)
};

const ru_discover_heading = /** @type {(inputs: Discover_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Что происходит`)
};

const tr_discover_heading = /** @type {(inputs: Discover_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sahada olup bitenler`)
};

const it_discover_heading = /** @type {(inputs: Discover_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cosa sta succedendo`)
};

const pl_discover_heading = /** @type {(inputs: Discover_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Co się dzieje`)
};

const uk_discover_heading = /** @type {(inputs: Discover_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Що відбувається`)
};

const hi_discover_heading = /** @type {(inputs: Discover_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`क्या हो रहा है`)
};

const ar_discover_heading = /** @type {(inputs: Discover_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ما يجري الآن`)
};

const ms_discover_heading = /** @type {(inputs: Discover_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apa yang sedang berlaku`)
};

const bn_discover_heading = /** @type {(inputs: Discover_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কী ঘটছে`)
};

const zh_tw2_discover_heading = /** @type {(inputs: Discover_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在發生的事`)
};

const zh_hk2_discover_heading = /** @type {(inputs: Discover_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在發生的事`)
};

const ur_discover_heading = /** @type {(inputs: Discover_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`کیا ہو رہا ہے`)
};

const fa_discover_heading = /** @type {(inputs: Discover_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`چه خبر است`)
};

const sw_discover_heading = /** @type {(inputs: Discover_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kinachoendelea`)
};

const nl_discover_heading = /** @type {(inputs: Discover_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat er speelt`)
};

/**
* | output |
* | --- |
* | "What's on the court" |
*
* @param {Discover_HeadingInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const discover_heading = /** @type {((inputs?: Discover_HeadingInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Discover_HeadingInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_discover_heading(inputs)
	if (locale === "ja") return ja_discover_heading(inputs)
	if (locale === "zh") return zh_discover_heading(inputs)
	if (locale === "es") return es_discover_heading(inputs)
	if (locale === "pt") return pt_discover_heading(inputs)
	if (locale === "id") return id_discover_heading(inputs)
	if (locale === "fr") return fr_discover_heading(inputs)
	if (locale === "tl") return tl_discover_heading(inputs)
	if (locale === "vi") return vi_discover_heading(inputs)
	if (locale === "ko") return ko_discover_heading(inputs)
	if (locale === "de") return de_discover_heading(inputs)
	if (locale === "ru") return ru_discover_heading(inputs)
	if (locale === "tr") return tr_discover_heading(inputs)
	if (locale === "it") return it_discover_heading(inputs)
	if (locale === "pl") return pl_discover_heading(inputs)
	if (locale === "uk") return uk_discover_heading(inputs)
	if (locale === "hi") return hi_discover_heading(inputs)
	if (locale === "ar") return ar_discover_heading(inputs)
	if (locale === "ms") return ms_discover_heading(inputs)
	if (locale === "bn") return bn_discover_heading(inputs)
	if (locale === "zh-TW") return zh_tw2_discover_heading(inputs)
	if (locale === "zh-HK") return zh_hk2_discover_heading(inputs)
	if (locale === "ur") return ur_discover_heading(inputs)
	if (locale === "fa") return fa_discover_heading(inputs)
	if (locale === "sw") return sw_discover_heading(inputs)
	if (locale === "nl") return nl_discover_heading(inputs)
	return en_discover_heading(inputs)
});